



























import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

@Component({
})
export default class ProductCard2 extends Vue {
  @Prop({ type: Object })
  product!: object

  public gotoLink (location: string) {
    window.location.href = location
  }
}
